import { Component, Input } from '@angular/core';
import { HideDownloadDirective } from '@cargos/sprintpay-ui';
import { FileHandlerService } from '../file-handler/services/file.service';
import { FileComponent } from './file/file.component';

@Component({
    selector: 'app-files-container',
    standalone: true,
    templateUrl: './files-container.component.html',
    imports: [FileComponent, HideDownloadDirective],
    providers: [FileHandlerService],
})
export class FilesContainerComponent {
    @Input() set filesPath(filesPath: string[]) {
        if (filesPath) {
            this.files = filesPath;
            this.nameFiles = this.fileService.getNameFiles(filesPath.join(','));
        }
    }
    @Input() title?: string = '';

    public nameFiles: string[] = [];
    public files: string[];
    constructor(private fileService: FileHandlerService) {}
}
